import React, { Component } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class MyItemListOptModalView extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onDeleteSelect: PropTypes.func.isRequired,
    onItemUploadClick: PropTypes.func.isRequired
  };

  handleUploadSelect = () => {
    const { onItemUploadClick, onClose } = this.props;
    onClose();
    onItemUploadClick();
  };

  handleDeleteSelect = () => {
    const { onDeleteSelect, onClose } = this.props;
    onClose();
    onDeleteSelect();
  };

  render() {
    const { open, onClose } = this.props;

    return (
      <CommonModalView
        open={open}
        onClose={onClose}
        buttonList={[
          {
            primary: <TXT name="btnList_uploadItem" />,
            secondary: null,
            func: this.handleUploadSelect
          },
          {
            primary: <TXT name="btnList_deleteItem" />,
            secondary: null,
            func: this.handleDeleteSelect
          }
        ]}
        firstButtonText={<TXT name="btnModal_close" />}
        firstButtonFunc={onClose}
      />
    );
  }
}

export default MyItemListOptModalView;
